import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { UiInfoCircleBoldIcon } from "@jti/brand-icons/ui-info-circle-bold";
import { Button } from "@jti/core-components/components/Button";

import "./DiscountBlock.scss";

const { sanitize } = dompurify;

export type DiscountBlockMessageProps = {
  variant?: "welcome" | "success" | "error";
  title?: string;
  subHeadline?: string;
  description?: string;
  welcomeText?: string;
  buttonLabel?: string;
  mobileBackgroundImage?: string;
  backgroundImageAlt?: string;
  pending?: boolean;
  onClick?: () => void;
};

const DiscountBlockMessage = ({
  variant,
  backgroundImageAlt,
  buttonLabel,
  mobileBackgroundImage,
  subHeadline,
  title,
  description,
  pending,
  onClick,
}: DiscountBlockMessageProps) => {
  return (
    <div className={classNames(["discount-block__content", variant])}>
      {variant === "success" && <UiCheckCircleIcon className="discount-block__icon" width="50px" height="50px" />}
      {variant === "error" && <UiInfoCircleBoldIcon className="discount-block__icon" width="50px" height="50px" />}
      {subHeadline && <h3 className="discount-block__subheadline">{subHeadline}</h3>}
      <h2 className="discount-block__headline">{title}</h2>
      <div
        className="discount-block__description"
        dangerouslySetInnerHTML={{ __html: sanitize(description || "") }}
      ></div>
      {buttonLabel && (
        <Button className="discount-block__button" onClick={onClick} variant="primary" pending={pending}>
          {buttonLabel}
        </Button>
      )}
      <img className="discount-block__background-image-mobile" src={mobileBackgroundImage} alt={backgroundImageAlt} />
    </div>
  );
};

export default DiscountBlockMessage;
